import App from './App.svelte';

const app = new App({
	target: document.body,
	hydrate: true,
	props: {
		// model_root: 'http://localhost/projects/pagels_garten/',
		// application_root: 'http://localhost/projects/',
		model_root: 'https://admin.dorfladen-gungolding.de/model/',
		application_root: 'https://admin.dorfladen-gungolding.de/'
	}
});

export default app;
